/* eslint-disable camelcase */
const practiceTitle = document.querySelector<HTMLElement>('.provider-hero__title')?.textContent;

const apptButton = document.querySelector<HTMLElement>('.provider-hero__cta');
if (null !== apptButton && practiceTitle) {
	apptButton.addEventListener('click', () => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'finda',
			event_action: `request_appt_button_clicked`,
			location_name: practiceTitle,
		});
	});
}

const practiceUrlEl = document.querySelector<HTMLElement>('.provider-hero__contact--website');
if (null !== practiceUrlEl) {
	practiceUrlEl.addEventListener('click', (e: MouseEvent) => {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'finda',
			event_action: `practice_url_selected`,
			location_name: practiceTitle,
		});
	});
}
